import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import "./Auth.css";
import { routes } from "../../routes.js";

const Auth = (props: any) => {
  const mainContent = React.useRef<HTMLDivElement>(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes: any) =>
    routes.map((prop: any, key: number) => {
      if (prop.layout === "/auth") {
        return (
          //@ts-ignore
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      }
      return null;
    });

  return (
    <div className="login-page" ref={mainContent}>
      <div className="login-left">
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </div>
      <div className="login-right">
        <img
          className="login-right__photo"
          src={require("../../assets/img/brand/banner portal carreira.png")}
          alt="Ambiente profissional"
        />
        <div className="login-right__overlay">
          <p className="login-right__title">Encontre sua próxima oportunidade</p>
          <p className="login-right__subtitle">Conectando talentos e empresas</p>
        </div>
      </div>
    </div>
  );
};

export default Auth;
